export const MATERIAL_OPTION_TEXTS = {
  members: (count) => `${count} ${count === 1 ? 'material' : 'materiales'}`,
  searchProvider: 'Buscar proveedor',
  searchWarehouse: 'Buscar depósito',
  searchGroup: 'Buscar grupo',
  searchArticle: 'Buscar material',
  searchProject: 'Buscar vivienda',
};
